export default "__VITE_ASSET__Ct3q95Xu__"